import { layoutRoute } from '@app/router/layout';
import { createRoute, Outlet } from '@tanstack/react-router';
import CreditsPage from '@modules/core/presentation/v2/pages/Credits';
import Payouts from '@modules/core/presentation/v2/pages/Payouts';
import { rootRoute } from '@app/router/root';
import { TermsAndConditions } from '@modules/core/presentation/v2/pages/TermsAndConditions';
import { PrivacyPolicy } from '@modules/core/presentation/v2/pages/PrivacyPolicy';
import { CreditsInfoPage } from '@modules/core/presentation/v2/pages/CreditsInfo';
import { Tutorials } from '@modules/core/presentation/v2/pages/Tutorials';

export type CreditsRouteSearchQuery = {
  page?: number;
};

export const PayoutsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/payouts',
  beforeLoad: () => ({
    breadcrumb: { key: 'payouts' },
    featureName: 'payouts.module',
  }),
  component: () => (
    <Payouts />
  ),
});

export const CreditsLayoutRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/credits',
  beforeLoad: () => ({ featureName: 'credits.module' }),
  component: () => <Outlet />,
});

export const CreditsRoute = createRoute({
  getParentRoute: () => CreditsLayoutRoute,
  path: '/',
  beforeLoad: () => ({ breadcrumb: { key: 'credits' } }),
  component: () => (
    <CreditsPage />
  ),
  validateSearch: (search: CreditsRouteSearchQuery): CreditsRouteSearchQuery => ({ page: search.page ?? 1 }),
});

export const CreditsInfoRoute = createRoute({
  getParentRoute: () => CreditsLayoutRoute,
  path: '/credits-info',
  beforeLoad: () => ({ breadcrumb: { key: 'credits' } }),
  component: () => (
    <CreditsInfoPage />
  ),
});

export const TermsAndConditionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms-and-conditions',
  component: () => (
    <TermsAndConditions />
  ),
});

export const PrivacyPolicyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy-policy',
  component: () => (
    <PrivacyPolicy />
  ),
});

export const TutorialsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/tutorials',
  beforeLoad: () => ({
    breadcrumb: { key: 'tutorials' },
    featureName: 'tutorials.module',
  }),
  component: () => (
    <Tutorials />
  ),
});
